
const _directiveDependencies = ['Templates'];
const _controllerDependencies = ['Util'];

class PcEmailDeploymentSuccessController {

    constructor(Util) {

        this.Util = Util;

    }

    close() {

        this.Util.closeModal();

    }

}

class PcEmailDeploymentSuccessDirective {

    constructor() {

        this.template = require('./pc-email-deployment-success.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(Util =>
            new PcEmailDeploymentSuccessController(Util));

        this.controller = _controllerDependencies;
        this.controllerAs = 'PcEmailDeploymentSuccessCtrl';

    }

}

_directiveDependencies.push(() =>
    new PcEmailDeploymentSuccessDirective());

angular.module('directives')
    .directive('pcEmailDeploymentSuccess', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/pc-email-deployment-success/pc-email-deployment-success.js